const permissions = require('./permissions');
const organisationUserRoles = require('./organisationUserRoles');

const bitPermissionsSum = (permissionsArray) => {
    return permissionsArray.reduce((permissionsSum, permission) => permissionsSum + permission.bitPermissions, 0);
};
/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    founder: {
        roleName: organisationUserRoles.FOUNDER,
        bitPermissions: bitPermissionsSum([permissions.READ_TARIFF_INFO, permissions.WRITE_ORGANISATION_TARIFF_INFO]),
    },
    admin: {
        roleName: organisationUserRoles.ADMIN,
        bitPermissions: bitPermissionsSum([permissions.READ_TARIFF_INFO]),
    },
    lecturer: {
        roleName: organisationUserRoles.LECTURER,
        bitPermissions: bitPermissionsSum([]),
    },
};
